import { CellClassParams, IRowNode } from 'ag-grid-enterprise';

import { DisplaySchema } from './display-schema';
import { DisplayType } from './display-type.enum';
import { SummitIdObject } from './summit-id-object';
import { ViewField } from './view/view-field';

export class SummitGridCellFunctions {
  static cellClassRules = {
    'rag-green-outer': function (params: CellClassParams): boolean {
      const filterManager = (params?.api as any)?.filterManager;
      if (!(filterManager?.quickFilter?.length > 0)) return false;
      const quickFilterText: string | undefined = params.colDef?.getQuickFilterText?.({
        value: params.value,
        node: params.node,
        data: params.node.data,
        column: params.column,
        colDef: params.colDef,
        context: params.context,
        api: params.api
      });
      return quickFilterText !== undefined && quickFilterText.toUpperCase().indexOf(filterManager?.quickFilter) >= 0;
    }
  };

  static computeCellClassRules<T extends SummitIdObject>(
    schema: DisplaySchema<T>,
    item: T | undefined,
    attribute: ViewField<T>
  ): string[] {
    const classes: string[] = [];

    //Import displayClass from schema (string or array of strings)
    if (attribute.displayClass) {
      if (Array.isArray(attribute.displayClass)) classes.push(...attribute.displayClass);
      else
        classes.push(
          ...attribute.displayClass
            .split(' ')
            .map((x) => x.trim())
            .filter((x) => x != '')
        );
    }
    //Import legacy getTDClassString
    const legacyTdClassString = schema && item ? schema.getTdClassString(item, attribute) : null;
    const legacyCellClasses = legacyTdClassString
      ? legacyTdClassString
          .split(' ')
          .map((x) => x.trim())
          .filter((x) => x != '')
      : [];
    classes.push(...legacyCellClasses);

    //Build params for cellClassRules
    const params: Partial<CellClassParams> = {
      data: item,
      value: item == null ? null : item[attribute.propertyName],
      node: {} as IRowNode<T>,
      context: {
        view: {}
      }
    };
    //Import cellClassRules from schema (object of functions)
    if (schema.rowClassRules) {
      Object.keys(schema.rowClassRules).forEach((key) => {
        const rule = schema.rowClassRules?.[key] as (params: Partial<CellClassParams>) => boolean;
        const result = rule(params);
        if (result) {
          classes.push(key);
        }
      });
    }
    //Import cellClassRules from attribute (object of functions)
    if (attribute.cellClassRules) {
      Object.keys(attribute.cellClassRules).forEach((key) => {
        const rule = attribute.cellClassRules?.[key] as (params: Partial<CellClassParams>) => boolean;
        const result = rule(params);
        if (result) {
          classes.push(key);
        }
      });
    }
    //Grid Defaults
    switch (attribute.displayType) {
      case DisplayType.Enum:
      case DisplayType.EnumArray:
        if (classes.findIndex((x) => x.indexOf('-align-') >= 0) < 0) classes.push('cell-align-center');
        else console.log('Enum cell has alignment class', classes);
        break;
      default:
        break;
    }

    return classes;
  }

  static CreateValueFormatterParams<T extends SummitIdObject>(value: T[keyof T] | unknown, item: T): CellClassParams {
    return {
      data: item,
      value: value,
      node: {} as IRowNode<T>,
      context: {
        view: {}
      }
    } as CellClassParams;
  }
}
